/** It takes array and item and returns array with unique values
 * @param array
 * @param item
 * */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const getUniqueArray = <T extends unknown>(array: T[], item: T): T[] => Array.from(new Set(array).add(item))
